import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Badge, Card, CardBody, CardHeader, Table, Row, Col } from "reactstrap";
import moment from "moment";
import ApiServer from "../helpers/Api_help";
import EventBookingModal from "../pages/event/EventBookingModal";

const BlogDetailsPage = ({ SelectedEventData }) => {
  const [selectedEvent, setSelectedEvent] = useState(null);

  const [bookingModalOpen, setBookingModalOpen] = useState(false);
const [iframeUrl, setIframeUrl] = useState("");

const openBookingModal = (url) => {
  setIframeUrl(url);
  setBookingModalOpen(true);
};

const toggleModal = () => {
  setBookingModalOpen(!bookingModalOpen);
};

  useEffect(() => {
    if (SelectedEventData) {
      setSelectedEvent(SelectedEventData);
    }
  }, [SelectedEventData]);

  if (!selectedEvent) {
    return <div className="container mt-5 text-center">Loading event details...</div>;
  }

  const venueData = selectedEvent.venues?.[0] || {};
const venueId = venueData?._id;
  return (
    <div className="container mt-4 mb-5">
      {/* HEADER SECTION */}
      <div className="mb-4 d-flex justify-content-between align-items-end border-bottom pb-3">
        <div>
          <h1 className="fw-bold text-dark mb-1">{selectedEvent.event_name}</h1>
          <p className="text-muted mb-0">
            <i className="mdi mdi-calendar-range me-2"></i>
            {moment(selectedEvent.start_date).format("MMMM Do YYYY")} | {venueData.venue}
          </p>
        </div>
        
      </div>

      <Row>
        {/* LEFT COLUMN: VISUALS & DESCRIPTION */}
        <Col lg="8">
          <Card className="border-0 shadow-sm overflow-hidden mb-4">
            {selectedEvent.image_url && (
              <img
                src={`${ApiServer}assets/event_cover/${selectedEvent.image_url}`}
                alt="event"
                className="img-fluid"
                // style={{ width: "100%", maxHeight: "450px", objectFit: "cover" }}
                style={{
  width: "100%",
  height: "auto",
  objectFit: "contain"
}}
              />
            )}
            <CardBody className="p-4">
              <h5 className="fw-bold mb-3">About This Event</h5>
              <p className="text-secondary" style={{ lineHeight: "1.6" }}>
                {selectedEvent.description || "No description provided."}
              </p>

              {/* FOOD MENU SECTION */}
            
{venueData?.enable_food_menu && venueData?.food_items?.length > 0 && (
  <div className="mt-4 pt-4 border-top">
    <h5 className="fw-bold mb-3 d-flex align-items-center">
      <i className="mdi mdi-silverware-variant me-2 text-primary"></i>
      Menu Highlights
    </h5>
    <Row>
      {venueData.food_items.map((f, i) => {
        // Dynamic color logic based on category
        const categoryKey = f.category.toLowerCase();
        let badgeColor = "secondary"; // default
        let icon = "mdi-circle-medium";

        if (categoryKey.includes("non")) {
          badgeColor = "danger"; // Red for Non-Veg
          icon = "mdi-food-drumstick";
        } else if (categoryKey.includes("vegan")) {
          badgeColor = "info"; // Teal/Blue for Vegan
          icon = "mdi-leaf";
        } else if (categoryKey.includes("veg")) {
          badgeColor = "success"; // Green for Veg
          icon = "mdi-leaf-dot";
        }

        return (
          <Col md="6" key={i} className="mb-3">
            <div className="d-flex align-items-center p-3 border rounded shadow-sm bg-white h-100">
              <div className={`bg-${badgeColor} bg-opacity-10 p-2 rounded me-3`}>
                <i className={`mdi ${icon} text-${badgeColor} fs-4`}></i>
              </div>
              <div className="flex-grow-1">
                <div className="d-flex justify-content-between align-items-start">
                  <span className="fw-bold text-dark d-block">{f.item_name}</span>
                  <Badge color={badgeColor} pill className="text-uppercase px-2" style={{ fontSize: '10px' }}>
                    {f.category}
                  </Badge>
                </div>
                {f.description && (
                  <p className="smaller text-muted mb-0 mt-1 line-clamp-1">
                    {f.description}
                  </p>
                )}
              </div>
            </div>
          </Col>
        );
      })}
    </Row>
  </div>
)}
            </CardBody>
          </Card>

          {/* PRICING SECTION */}
          {(venueData?.ticket_pricing?.pricing?.length > 0 || venueData?.food_pricing?.length > 0) && (
            <div className="mt-4">
              <h4 className="fw-bold mb-3">Pricing Details</h4>
              
              {/* Tickets */}
              {venueData?.ticket_pricing?.pricing?.length > 0 && (
                <Card className="border-0 shadow-sm mb-3">
                  <CardHeader className="bg-white fw-bold">Ticket</CardHeader>
                  <CardBody className="p-0">
                    <Table responsive hover className="mb-0">
                      <thead className="table-light">
                        <tr>
                          <th className="ps-4">Audience</th>
                          <th>Age Group</th>
                          {venueData.enable_early_bird && <th>Early Bird</th>}
                          <th className="pe-4">Standard</th>
                        </tr>
                      </thead>
                      <tbody>
                        {venueData.ticket_pricing.pricing.map((p, i) => (
                          <tr key={i}>
                            <td className="ps-4 text-capitalize">{p.audience_type.replace('_', ' ')}</td>
                            <td className="text-capitalize">{p.age_group}</td>
                            {venueData.enable_early_bird && <td className="text-success fw-bold">${p.early_bird_cost}</td>}
                            <td className="pe-4 fw-bold">${p.standard_cost}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </CardBody>
                </Card>
              )}

              {/* Food Pricing */}
              {/* {venueData?.food_pricing?.map((food, idx) => ( */}
              {venueData?.food_pricing
  ?.filter(food =>
    food.pricing?.some(p => p.standard_cost > 0 || p.early_bird_cost > 0)
  )
  .map((food, idx) => {
    
    const hasEarly = food.pricing.some(p => p.early_bird_cost > 0);
    const hasStandard = food.pricing.some(p => p.standard_cost > 0);

    return (
      <Card key={idx} className="border-0 shadow-sm mb-3">
        <CardHeader className="bg-white fw-bold text-capitalize">
          {food.food_type.replace('_', ' ')}
        </CardHeader>

        <CardBody className="p-0">
          <Table responsive hover className="mb-0">
            
            {/* ✅ TABLE HEADER (LIKE TICKET) */}
            <thead className="table-light">
              <tr>
                <th className="ps-4">Audience</th>
                <th>Age Group</th>
                {hasEarly && <th>Early Bird</th>}
                {hasStandard && <th className="pe-4">Standard</th>}
              </tr>
            </thead>

            <tbody>
              {food.pricing
                .filter(p => p.standard_cost > 0 || p.early_bird_cost > 0)
                .map((p, i) => (
                  <tr key={i}>
                    
                    {/* Audience */}
                    <td className="ps-4 text-capitalize">
                      {p.audience_type.replace('_', ' ')}
                    </td>

                    {/* Age */}
                    <td className="text-capitalize">
                      {p.age_group}
                    </td>

                    {/* Early Bird */}
                    {hasEarly && (
                      <td className="text-success fw-bold">
                        {p.early_bird_cost > 0 ? `$${p.early_bird_cost}` : "-"}
                      </td>
                    )}

                    {/* Standard */}
                    {hasStandard && (
                      <td className="pe-4 fw-bold">
                        {p.standard_cost > 0 ? `$${p.standard_cost}` : "-"}
                      </td>
                    )}

                  </tr>
                ))}
            </tbody>

          </Table>
        </CardBody>
      </Card>
    );
  })}
              {/* {venueData?.food_pricing
  ?.filter(food => food.pricing?.some(p => p.standard_cost > 0))
  .map((food, idx) => (
                food.pricing?.length > 0 && (
                  <Card key={idx} className="border-0 shadow-sm mb-3">
                    <CardHeader className="bg-white fw-bold text-capitalize">
                      {food.food_type.replace('_', ' ')} 
                    </CardHeader>
                    <CardBody className="p-0">
                      <Table responsive hover className="mb-0">
                        <tbody borderless>
                           {food.pricing
  .filter(p => p.standard_cost > 0)
  .map((p, i) => (
                            <tr key={i}>
                              <td className="ps-4 text-muted">{p.audience_type.replace('_', ' ')} ({p.age_group})</td>
                              <td className="text-end pe-4 fw-bold text-success">+ ${p.standard_cost}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                )
              ))} */}
            </div>
          )}
        </Col>

        {/* RIGHT COLUMN: SIDEBAR INFO */}
        <Col lg="4">
          {/* LOCATION & TIME */}
          <Card >
            <CardBody>
              
              <div className="mt-3">
                <p className="mb-1 fw-bold">{venueData.venue}</p>
                <p className="small mb-3 opacity-75">{venueData.address}, {venueData.city}</p>
                
                {venueData?.enable_session && venueData?.session?.map((s, i) => (
                  <div key={i} className="border-top border-white border-opacity-25 pt-2 mt-2">
                    <p className="mb-0 small fw-bold">{s.session_name}</p>
                    <p className="mb-0 smaller opacity-75">
                      {moment(s.start_datetime).format("DD MMM, hh:mm A")} - {moment(s.end_datetime).format("DD MMM, hh:mm A")}
                    </p>
                  </div>
                ))}
              </div>
              {venueData?.enable_booking && (
                <button
  className="btn btn-warning w-100 mt-3"
  onClick={() => {
    const user = JSON.parse(localStorage.getItem("user_id"));
    const memberID = user?._id || "";

    const url = `${ApiServer}view-pug?eventId=${selectedEvent._id}&venueId=${venueData._id}&memberID=${memberID}`;

    openBookingModal(url);
  }}
>
  Book Now
</button>)}
            </CardBody>
          </Card>

          {/* ORGANIZERS */}
          {venueData?.enable_venue_organizer && venueData?.venue_organizer?.length > 0 && (
            <Card className="border-0 shadow-sm mb-4">
              <CardHeader className="bg-white fw-bold">Organized By</CardHeader>
              <CardBody>
                {venueData.venue_organizer.map((o, i) => (
                  <div key={i} className="mb-3 last-child-mb-0">
                    <p className="mb-0 fw-bold text-primary">{o.organizer_name}</p>
                    <p className="small text-muted mb-0">{o.role}</p>
                    <p className="small mb-0 mt-1">
                      <i className="mdi mdi-phone me-1"></i>{o.contact_number}
                    </p>
                  </div>
                ))}
              
              </CardBody>
            </Card>
          )}

          {/* PARKING */}
          {venueData?.enable_parking && venueData?.parking?.length > 0 && (
            <Card className="border-0 shadow-sm mb-4 border-start border-4 border-info">
              <CardBody>
                <h6 className="fw-bold mb-2">
                  <i className="mdi mdi-p-circle text-info me-2"></i>Parking Information
                </h6>
                {venueData.parking.map((p, i) => (
                  <div key={i} className="small text-muted">
                    <p className="fw-bold text-dark mb-0">{p.parking_name}</p>
                    <p className="mb-1">{p.parking_address}</p>
                   <div className="d-flex flex-wrap gap-2 mt-2">
  {p.vehicle_type.includes("both") || p.vehicle_type.includes("car") ? (
    <span className="d-flex align-items-center bg-light border rounded-pill px-2 py-1 small fw-medium">
      <i className="mdi mdi-car me-1 text-primary"></i> Car
    </span>
  ) : null}
  
  {p.vehicle_type.includes("both") || p.vehicle_type.includes("bike") ? (
    <span className="d-flex align-items-center bg-light border rounded-pill px-2 py-1 small fw-medium">
      <i className="mdi mdi-motorbike me-1 text-primary"></i> Bike
    </span>
  ) : null}
</div>
                  </div>
                ))}
              </CardBody>
            </Card>
          )}

           
 {/* SESSIONS SECTION - ONLY SHOWS IF ENABLED */}
{venueData?.enable_session && venueData?.session?.length > 0 && (
  <Card className="border-0 shadow-sm mb-4">
    <CardHeader className="bg-white border-bottom-0 pb-0">
      <h6 className="small fw-bold text-uppercase text-primary mb-0 d-flex align-items-center">
        <i className="mdi mdi-calendar-clock me-2 fs-5"></i> Session
      </h6>
    </CardHeader>
    <CardBody>
      {venueData.session.map((s, i) => (
        <div 
          key={s._id || i} 
          className="mb-3 p-3 rounded border-start border-4 border-primary bg-light bg-opacity-50"
        >
          <div className="d-flex justify-content-between align-items-start mb-2">
            <p className="mb-0 fw-bold text-dark">{s.session_name}</p>
            {s.zone && (
              <Badge color="primary" pill className="px-2 py-1" style={{ fontSize: '10px' }}>
                {s.zone}
              </Badge>
            )}
          </div>
          
          <div className="text-muted" style={{ fontSize: '0.8rem' }}>
            <div className="d-flex align-items-center mb-1">
              <i className="mdi mdi-clock-start me-2 text-success"></i>
              <span className="fw-medium me-1">Starts:</span>
              <span>{moment(s.start_datetime).format("MMM DD, hh:mm A")}</span>
            </div>
            <div className="d-flex align-items-center">
              <i className="mdi mdi-clock-end me-2 text-danger"></i>
              <span className="fw-medium me-1">Ends:</span>
              <span>{moment(s.end_datetime).format("MMM DD, hh:mm A")}</span>
            </div>
          </div>

          {s.description && (
            <div className="mt-2 pt-2 border-top border-2 border-white">
              <p className="mb-0 small text-secondary fst-italic">
                {s.description}
              </p>
            </div>
          )}
        </div>
      ))}
    </CardBody>
  </Card>
)}

        </Col>
      </Row>
      <EventBookingModal
  modalOpen={bookingModalOpen}
  toggleModal={toggleModal}
  iframeUrl={iframeUrl}
/>
    </div>
  );
};

export default BlogDetailsPage;